import { jwtDecode } from '@raas/shared/src/auth/utils';
import localStorageAvailable from '@raas/shared/src/utils/localStorageAvailable';

export function isEditEnabled() {
  const storageAvailable = localStorageAvailable();
  const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
  const { roles, hasInternalAccess } = jwtDecode(accessToken);

  if (roles) {
    return roles.includes('INTERNAL_ACCESS');
  }
  return hasInternalAccess;
}

export function isEnabled(requiredPermission: string) {
  const storageAvailable = localStorageAvailable();
  const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
  const { roles, hasInternalAccess, hasExternalAccess, hasLegalRequirementAccess } =
    jwtDecode(accessToken);

  // TODO asc: can be removed when only internal accesTokens are used
  if (roles) {
    return roles.includes(requiredPermission);
  }

  if (requiredPermission === 'INTERNAL_ACCESS') {
    return hasInternalAccess;
  }
  if (requiredPermission === 'EXTERNAL_ACCESS') {
    return hasExternalAccess;
  }
  if (requiredPermission === 'LEGAL_REQUIREMENTS') {
    return hasLegalRequirementAccess;
  }
  return false;
}
